import React, { Component } from 'react';
import swal from 'sweetalert';
import InputForm from '../../../components/InputForm';
import LabelForm from '../../../components/LabelForm';
import Modal from '../../../components/Modal';
import { donationComplementaryId, donationComplementarySave } from '../../../libs/services';

class ModalReportExtraction extends  Component{
    constructor(props){
        super(props);

        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.onSave = this.onSave.bind(this);

        this.state = {
            id:'',
            donation_id:'',
            basal:'',
            picking:'',
            picking_red:'',
            weight:'',
            volume:'',
            volume_red:''
        }
    }

    componentDidMount(){
		this.props.onRef(this);
	}

    componentWillUnmount(){
		this.props.onRef(null);
	}

    async openModal(id){
        var response = await donationComplementaryId(id, this.props.waiting);
        if(response !== undefined && response !== null){
            await this.setState({
                id:response.id,
                basal:response.basal,
                picking:response.picking,
                picking_red:response.picking_red,
                weight:response.weight,
                volume:response.volume,
                volume_red:response.volume_red
            });
        }
        await this.setState({
            donation_id:id
        });
        await this.modal.handleShow();
    }

    closeModal(){
        this.setState({
            basal:'',
            picking:'',
            picking_red:'',
            weight:'',
            volume:'',
            volume_red:''
        });
    }

    handleChange(e){
        this.setState({[e.target.name]: e.target.value});
    }

    async onSave(){
        var obj = {
            basal:this.state.basal,
            picking:this.state.picking,
            picking_red:this.state.picking_red,
            weight:this.state.weight,
            volume:this.state.volume,
            volume_red:this.state.volume_red,
            donation_id:this.state.donation_id
        };

        if(this.state.id !== ''){
            obj.id = this.state.id;
        }
        
        var valid = false;
        for (let clave in this.state){            
            if(this.state[clave] !== '' && clave !== 'donation_id'){
                valid = true;
            }
        }

        if(valid){
            var response = await donationComplementarySave(this.state.id, obj, this.props.waiting);
            if(response){
                this.modal.handleClose();
            }
        }else{
            swal('Error', 'Por lo menos debe agregar un valor a alguno de los campos.', 'error');
        }
    }

    render(){
        return(
            <Modal
                {...this.props}
                title="Reporte"
                clear={this.closeModal}
                action={this.onSave}
                actionBtn={true}
                label="Guardar"
                size="sm"
                onRef={ref => this.modal = ref}
            >
                <div className='row'>
                    <div className='col-xs-12'>
                        <div className='col-xs-12'>
                            <LabelForm text="Basal 2 CD34+" />
                            <InputForm 
                                id="basal"
                                value={this.state.basal}
                                handleChange={this.handleChange}
                            />
                        </div>
                        <div className='col-xs-12'>
                            <LabelForm text="Cosecha 2" />
                            <InputForm 
                                id="picking"
                                value={this.state.picking}
                                handleChange={this.handleChange}
                            />
                        </div>
                        <div className='col-xs-12'>
                            <LabelForm text="Cosecha 2 RED" />
                            <InputForm 
                                id="picking_red"
                                value={this.state.picking_red}
                                handleChange={this.handleChange}
                            />
                        </div>
                        <div className='col-xs-12'>
                            <LabelForm text="Peso" />
                            <InputForm 
                                id="weight"
                                value={this.state.weight}
                                handleChange={this.handleChange}
                            />
                            </div>
                        <div className='col-xs-12'>
                            <LabelForm text="Vol" />
                            <InputForm 
                                id="volume"
                                value={this.state.volume}
                                handleChange={this.handleChange}
                            />
                        </div>
                        <div className='col-xs-12'>
                            <LabelForm text="Vol Red C2" />
                            <InputForm 
                                id="volume_red"
                                value={this.state.volume_red}
                                handleChange={this.handleChange}
                            />
                        </div>
                    </div>
                </div>
            </Modal>
        )
    }
}

export default ModalReportExtraction;
